// List of filenames (including all files)
export const COMPANY_FILES = [
'202504112139_8309a0fffffffff_brotli.parquet',
'202504112139_8309a4fffffffff_brotli.parquet',
'202504112139_8309a6fffffffff_brotli.parquet',
'202504112139_83180dfffffffff_brotli.parquet',
'202504112139_831829fffffffff_brotli.parquet',
'202504112139_83182dfffffffff_brotli.parquet',
'202504112139_831870fffffffff_brotli.parquet',
'202504112139_831872fffffffff_brotli.parquet',
'202504112139_831874fffffffff_brotli.parquet',
'202504112139_831875fffffffff_brotli.parquet',
'202504112139_831876fffffffff_brotli.parquet',
'202504112139_831901fffffffff_brotli.parquet',
'202504112139_831908fffffffff_brotli.parquet',
'202504112139_831909fffffffff_brotli.parquet',
'202504112139_83190afffffffff_brotli.parquet',
'202504112139_83190bfffffffff_brotli.parquet',
'202504112139_83190cfffffffff_brotli.parquet',
'202504112139_83190dfffffffff_brotli.parquet',
'202504112139_83190efffffffff_brotli.parquet',
'202504112139_831928fffffffff_brotli.parquet',
'202504112139_831929fffffffff_brotli.parquet',
'202504112139_83192afffffffff_brotli.parquet',
'202504112139_83192bfffffffff_brotli.parquet',
'202504112139_83192cfffffffff_brotli.parquet',
'202504112139_831940fffffffff_brotli.parquet',
'202504112139_831941fffffffff_brotli.parquet',
'202504112139_831942fffffffff_brotli.parquet',
'202504112139_831943fffffffff_brotli.parquet',
'202504112139_831946fffffffff_brotli.parquet',
'202504112139_831948fffffffff_brotli.parquet',
'202504112139_83194afffffffff_brotli.parquet',
'202504112139_83194cfffffffff_brotli.parquet',
'202504112139_83194efffffffff_brotli.parquet',
'202504112139_831950fffffffff_brotli.parquet',
'202504112139_831951fffffffff_brotli.parquet',
'202504112139_831953fffffffff_brotli.parquet',
'202504112139_831954fffffffff_brotli.parquet',
'202504112139_831955fffffffff_brotli.parquet',
'202504112139_831956fffffffff_brotli.parquet',
'202504112139_831958fffffffff_brotli.parquet',
'202504112139_831959fffffffff_brotli.parquet',
'202504112139_83195afffffffff_brotli.parquet',
'202504112139_83195bfffffffff_brotli.parquet',
'202504112139_83195cfffffffff_brotli.parquet',
'202504112139_83195dfffffffff_brotli.parquet',
'202504112139_83195efffffffff_brotli.parquet',
'202504112139_831972fffffffff_brotli.parquet',
'202504112139_831973fffffffff_brotli.parquet',
'202504112139_831976fffffffff_brotli.parquet'];